/* eslint-disable react-hooks/exhaustive-deps */
'use client'

import internalReset from '@/useCases/errors/internalReset'
import isReleaseError from '@/useCases/errors/isReleaseError'
import * as Sentry from '@sentry/nextjs'
import { useCallback, useEffect } from 'react'

export default function GlobalError({
  error,
  reset,
}: {
  error: Error
  reset: () => void
}) {
  useEffect(() => {
    Sentry.captureException(error)
  }, [error])

  const triggerReset = useCallback(async () => {
    try {
      if (isReleaseError(error)) {
        console.log('👹 ~ Error: GLOBAL_ERROR')
        await internalReset(reset)
      }
    } catch (resetError) {
      console.error('Failed to reset after global error:', resetError)
    }
  }, [error, reset])

  useEffect(() => {
    // Log the error to console for debugging
    console.error('Global application error:', error)

    // Trigger reset if it's a release-related error
    triggerReset()
  }, [error, triggerReset])

  return (
    <div>
      <h2>Something went wrong!</h2>
      <h3>{error.message}</h3>
      <button onClick={() => triggerReset()}>Try again</button>
    </div>
  )
}
